import * as React from 'react';
import { Slider } from '@cian/slider';
import { Responsive } from '@cian/ui-kit';

import { OnboardingSlidesContainer, OnboardingSwitcherContainer } from '../index';
import { OnboardingLayout } from '../../../../components/OnboardingLayout';

import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import { IOnboardingPropsWithFn } from '../../types';

export const OnboardingContainer: React.FC<IOnboardingPropsWithFn> = ({
  slides,
  trackShowOnboardingModal,
  trackClickOnboardingButton,
  trackClickOnboardingBackButton,
  closeOnboardingModal,
  onFinishClick,
}) => {
  return (
    <ActionAfterViewObserver callback={trackShowOnboardingModal}>
      <>
        <Responsive desktop tablet>
          <OnboardingLayout>
            <Slider>
              <OnboardingSlidesContainer slides={slides} />
              <OnboardingSwitcherContainer
                slides={slides}
                trackClickOnboardingButton={trackClickOnboardingButton}
                trackClickOnboardingBackButton={trackClickOnboardingBackButton}
                closeOnboardingModal={closeOnboardingModal}
                onFinishClick={onFinishClick}
              />
            </Slider>
          </OnboardingLayout>
        </Responsive>
        <Responsive phone>
          <OnboardingLayout isMobile>
            <Slider>
              <OnboardingSlidesContainer slides={slides} isMobile />
              <OnboardingSwitcherContainer
                slides={slides}
                trackClickOnboardingButton={trackClickOnboardingButton}
                trackClickOnboardingBackButton={trackClickOnboardingBackButton}
                closeOnboardingModal={closeOnboardingModal}
                isMobile
                onFinishClick={onFinishClick}
              />
            </Slider>
          </OnboardingLayout>
        </Responsive>
      </>
    </ActionAfterViewObserver>
  );
};
